// Sidebar.jsx
import { NavLink } from "react-router-dom";
import { Listbox } from "@headlessui/react";
import {
  FiHome,
  FiFileText,
  FiZap,
  FiChevronRight,
  FiChevronLeft,
  FiChevronDown,
  FiCheck,
} from "react-icons/fi";
import { TbDeviceAnalytics } from "react-icons/tb";
import { BsFillVinylFill, BsSearch } from "react-icons/bs";
import { useEffect, useRef, useState } from "react";
import { parseJwt } from "../pages/Dashboard/Dashboard";
import PrimaryColorButton from "./PrimaryColorButton";
import { FaUserCircle } from "react-icons/fa";
import { useTeamService } from "../api/teamService";
import TeamSelector from "../components/TeamSelector";
import cursorArrowRays from "../assets/cursor-arrow-rays.svg";

export default function Sidebar() {
  const token = localStorage.getItem("authToken");
  const user = parseJwt(token || "");
  const asideRef = useRef<HTMLDivElement | null>(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { teamsForMember } = useTeamService();

  const handleProfileNav = () => {
    if (user) {
      window.location.href = "/profile/user/";
    }
  };

  return (
    <aside
      ref={asideRef}
      className={`h-screen sticky top-0 bg-gray-50 border-r border-gray-200 transition-[width] duration-300 ${
        isCollapsed ? "w-20" : "w-56"
      }`}
    >
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="p-2 rounded-lg hover:bg-gray-200"
      >
        {isCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
      </button>
      <div className="flex items-center justify-between p-4">
        <NavLink to="/" className="flex items-center transition-none">
          {isCollapsed ? (
            <img src="/favicon.png" alt="Logo Q" className="h-auto w-auto" />
          ) : (
            <img src="/Logo-light.svg" alt="Logo" className="h-8 w-auto" />
          )}
        </NavLink>
        <button className="hidden">
          <BsSearch size={20} />
        </button>
      </div>
      <div className="flex p-4 flex-col">
        <TeamSelector collapsed={isCollapsed} />

        <div
          className={`flex justify-start mt-2 text-gray-700 ${
            isCollapsed ? "hidden" : "block"
          }`}
        >
          <PrimaryColorButton
            onClick={handleProfileNav}
            text="View profile"
            icon={<FaUserCircle />}
          />
        </div>
      </div>
      <nav
        className={`mt-4 flex flex-col ${
          isCollapsed ? "items-center" : ""
        } transition-all duration-300`}
      >
        <NavLink to="/" className="flex items-center p-4 hover:bg-gray-200">
          <img src={cursorArrowRays} className="w-6 h-6" />
          <span className={`ml-1 text-gray-700 ${isCollapsed ? "hidden" : ""}`}>
            Quick Actions
          </span>
        </NavLink>
        <NavLink
          to="/analytics/manager"
          className="flex items-center px-4 pt-4 pb-2 hover:bg-gray-200"
        >
          <TbDeviceAnalytics className="text-gray-500" size={20} />
          <span className={`ml-2 text-gray-700 ${isCollapsed ? "hidden" : ""}`}>
            Manager Analytics
          </span>
        </NavLink>
        <hr className="h-0.5 mx-2 my-2 bg-gray-200 border-0" />
        <NavLink to="/runs" className="flex items-center p-4 hover:bg-gray-200">
          <FiZap className="text-gray-500" size={20} />
          <span className={`ml-2 text-gray-700 ${isCollapsed ? "hidden" : ""}`}>
            Live
          </span>
        </NavLink>
        {/* <NavLink
          to="/releases"
          className="flex items-center p-4 hover:bg-gray-200"
        >
          <BsFillVinylFill className="text-gray-500" size={20} />
          <span className={`ml-2 text-gray-700 ${isCollapsed ? "hidden" : ""}`}>
            Recorded
          </span>
        </NavLink> */}

        <NavLink
          to="/documents"
          className="flex items-center p-4 hover:bg-gray-200"
        >
          <FiFileText className="text-gray-500" size={20} />
          <span className={`ml-2 text-gray-700 ${isCollapsed ? "hidden" : ""}`}>
            Documents
          </span>
        </NavLink>
        <NavLink
          to="/analytics"
          className="flex items-center p-4 hover:bg-gray-200"
        >
          <TbDeviceAnalytics className="text-gray-500" size={20} />
          <span className={`ml-2 text-gray-700 ${isCollapsed ? "hidden" : ""}`}>
            Analytics
          </span>
        </NavLink>
        {/* <NavLink
          to="/report"
          className="flex items-center p-4 hover:bg-gray-200"
        >
          <FiBarChart2 className="text-gray-500" size={20} />
          <span className="ml-2 text-gray-700">Report</span>
        </NavLink>
        <NavLink
          to="/analytics"
          className="flex items-center p-4 hover:bg-gray-200"
        >
          <FiUsers className="text-gray-500" size={20} />
          <span className="ml-2 text-gray-700">Analytics</span>
        </NavLink> */}
      </nav>
    </aside>
  );
}
